<!--begin::Purchase link-->
<a
  href="{{ appPurchaseUrl}}"
  target="_blank"
  class="engage-purchase-link btn btn-flex h-35px bg-body btn-color-gray-700 btn-active-color-gray-900 px-5 shadow-sm rounded-top-0" >
  Buy Now
</a>
<!--end::Purchase link-->
